import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=3650b2c2&scoped=true&"
import script from "./sticky.vue?vue&type=script&lang=js&"
export * from "./sticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650b2c2",
  null
  
)

export default component.exports